import { SelectHelperMenuItem, Text, useLocale, VFlow } from 'bold-ui'
import { SelectField } from 'components/form'
import { AsyncSelectFieldProps, useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { HLabel } from 'components/HLabel'
import { Cpf } from 'components/label'
import { LotacoesComRegulacoesSelectFieldDocument } from 'graphql/hooks.generated'
import {
  LotacoesComRegulacoesSelectFieldQuery,
  LotacoesComRegulacoesSelectFieldQueryVariables,
} from 'graphql/types.generated'
import React from 'react'

export type LotacoesComRegulacoesSelectFieldModel = LotacoesComRegulacoesSelectFieldQuery['lotacoesComRegulacoes'][0]

interface LotacoesComRegulacoesSelectFieldProps extends AsyncSelectFieldProps<LotacoesComRegulacoesSelectFieldModel> {}

export const LotacoesComRegulacoesSelectField = (props: LotacoesComRegulacoesSelectFieldProps) => {
  const { skipping, selectProps } = useAsyncQuerySelect<
    LotacoesComRegulacoesSelectFieldModel,
    LotacoesComRegulacoesSelectFieldQuery,
    LotacoesComRegulacoesSelectFieldQueryVariables
  >({
    query: LotacoesComRegulacoesSelectFieldDocument,
    extractItems: (data) => data?.lotacoesComRegulacoes,
    variables: (query) => ({
      input: {
        nomeProfissional: query,
      },
    }),
    debounceTime: 500,
  })

  return (
    <SelectField<LotacoesComRegulacoesSelectFieldModel>
      itemToString={itemToString}
      renderItem={renderItem}
      components={{ EmptyItem: () => EmptyMenuItem({ skipping }) }}
      {...selectProps}
      {...props}
    />
  )
}

const itemToString = (item: LotacoesComRegulacoesSelectFieldModel) => item?.profissional?.nome

const renderItem = (item: LotacoesComRegulacoesSelectFieldModel) => (
  <VFlow vSpacing={0}>
    <Text fontWeight='bold'>
      {item.profissional.nome} - <Cpf value={item.profissional.cpf} /> {!item.ativo && ' (Inativa)'}
    </Text>
    <HLabel title='CBO '>{`${item.cbo.nome} - ${item.cbo.cbo2002}`}</HLabel>
    <HLabel title='INE '> {(item.equipe && `${item.equipe.nome} - ${item.equipe.ine}`) || 'Sem equipe'}</HLabel>
  </VFlow>
)

const EmptyMenuItem = ({ skipping }: { skipping: boolean }) => {
  const locale = useLocale()

  return (
    <SelectHelperMenuItem>
      {skipping ? 'Digite para buscar uma lotação.' : locale.select.emptyItem}
    </SelectHelperMenuItem>
  )
}
